import React from 'react'
import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { ASSETS_UNDER_MANAGE, CREDENTIALS, FIRM_TYPE, NUMBER_OF_EMPLOYEES, PRIMARY_CLIENT_SEGMENT, SPECIALTY_TYPE, YEARS_IN_BUSINESS, assetsUnderManageArray, credentialsArray, employmentArray, firmTypeArray, numberOfEmployeesArray, primaryClientSegmentArray, specialtyArray, yearsInBusinessArray } from '../../AnnualConference/Registration/Dashboard/Employment/model'

const userRecordFields = [
    {
        label: "First Name",
        value: "fname",
        type: "text",
    },
    {
        label: "Last Name",
        value: "lname",
        type: "text",
    },
    {
        label: "Firm Name",
        value: "firmname",
        type: "text",
    },
    {
        label: "Ship Firm Name",
        value: "shipfirmname",
        type: "text",
    },
    {
        label: "Ship Address",
        value: "shipaddress",
        type: "text",
    },
    {
        label: "Ship City",
        value: "shipcity",
        type: "text",
    },
    {
        label: "Ship State",
        value: "shipstate",
        type: "text",
    },
    {
        label: "Ship Country",
        value: "shipcountry",
        type: "text",
    },
    {
        label: "Bill Firm Name",
        value: "billfirmname",
        type: "text",
    },
    {
        label: "Bill Address",
        value: "billaddress",
        type: "text",

    },
    {
        label: "Bill City",
        value: "billcity",
        type: "text",
    },
    {
        label: "Bill State",
        value: "billstate",
        type: "text",
    },
    {
        label: "Bill Country",
        value: "billcountry",
        type: "text",
    },
    {
        label: "Email",
        value: "email",
        type: "text",
    },
    {
        label: "Referred By",
        value: "referred_by",
        type: "text",
    },
    {
        label: "Date Membership Joined",
        value: "d_memjoin",
        type: "date"
    },
    {
        label: "Date Membership Expires",
        value: "d_memexp",
        type: "date"
    },
    {
        label: "Date CKA Applied",
        value: "d_certapp",
        type: "date"
    },
    {
        label: "Date Certified",
        value: "d_memcert",
        type: "date"
    },
    {
        label: "Date CKA Expires",
        value: "d_certexp",
        type: "date"
    },
    {
        label: "Date Passed CKA Exam",
        value: "ckaed_date_exam_passed",
        type: "date"
    },
    {
        label: "CKA Ed Institution",
        value: "ckaed_institution",
        type: "text",
    },
    {
        label: "CKA Ed Graduation",
        value: "ckaed_grad_date",
        type: "date"
    },
    {
        label: "Student Expected Grad Year",
        value: "st_graduation",
        type: "date"
    },
    {
        label: "FBI Search Opt In",
        value: "fbi_search",
        type: "boolean"
    },
    {
        label: "Partner Level",
        value: "partner_level",
        type: "select",
        getOptions: () => ([
            {
                label: "Title Partner",
                value: 1
            },
            {
                label: "Platinum Partner",
                value: 2
            },
            {
                label: "Gold Partner",
                value: 3
            },
            {
                label: "Silver Partner",
                value: 4
            },
            {
                label: "Bronze Partner",
                value: 5
            },
            {
                label: "Inactive Partner",
                value: 8
            },
            {
                label: "Partner Setup",
                value: 9
            }
        ])
    },
    {
        label: "Membership Type",
        value: "member_type",
        type: "select",
        getOptions: (o) => (o || []),
    },
    {
        label: "KA Champion",
        value: "grp_kachampion",
        type: "boolean"
    },
    {
        label: "Broker Dealer",
        value: "broker",
        type: "text"
    },
    {
        label: "CRD#",
        value: "crd",
        type: "text"
    },

]

export const userRecordsConditions = [
    {
        label: "is like",
        value: "is like",
    },
    {
        label: "is not like",
        value: "is not like",
    },
    {
        label: "contains",
        value: "contains",
    },
    {
        label: "does not contain",
        value: "does not contain",
    },
    {
        label: "begins with",
        value: "begins with",
    },
    {
        label: "ends with",
        value: "ends with",
    },
    {
        label: "is empty",
        value: "is empty",
    },
    {
        label: "is not empty",
        value: "is not empty",
    },
    {
        label: "is between",
        value: "is between",
    },
    {
        label: "is not between",
        value: "is not between",
    },
    {
        label: "is in list",
        value: "is in list",
    },
    {
        label: "is not in list",
        value: "is not in list",
    },
    {
        label: "greater than",
        value: "greater than",
    },
    {
        label: "less than",
        value: "less than",
    }
]

export const profileRecordsConditions = [
    {
        label: "is like",
        value: "is like",
    },
    {
        label: "is not like",
        value: "not like",
    }

]

const profileRecordFields = [
    {
        label: "Employment",
        value: "employment",
        type: 'dropdown'
    },
    {
        label: "Specialty",
        value: "specialty",
        type: 'dropdown'
    },
    {
        label: "Firm Type",
        value: "firm_type",
        type: 'dropdown'
    },
    {
        label: "Primary Client Segment",
        value: "primary_client_segment",
        type: 'dropdown'
    },
    {
        label: "Number of Employees",
        value: "number_of_employees",
        type: 'dropdown'
    },
    {
        label: "Years in Business",
        value: "years_in_business",
        type: 'dropdown'
    },
    {
        label: "Assets Under Management",
        value: "assets_under_management",
        type: 'dropdown'
    },
    {
        label: "Credentials",
        value: "credentials",
        type: 'dropdown'
    },
]

const saleRecordFields = [
    {
        label: "Has purchased",
        value: "has_purchased",
        type: "text"
    },
    {
        label: "Has not purchased",
        value: "has_not_purchased",
        type: "text"
    }

]
export const userFieldValueIsUnsupported = (condition) => {
    switch (condition) {
        case "is empty":
        case "is not empty":
        case "is in list":
        case "is not in list":
            return true
        default:
            return false

    }
}

export const getProfileFieldValues = (field) => {
    switch (field) {
        case "employment":
            return employmentArray;
        case "specialty":
            return specialtyArray
        case "firm_type":
            return firmTypeArray
        case "primary_client_segment":
            return primaryClientSegmentArray
        case "number_of_employees":
            return numberOfEmployeesArray
        case "years_in_business":
            return yearsInBusinessArray
        case "assets_under_management":
            return assetsUnderManageArray
        case "credentials":
            return credentialsArray
        default:
            return []
    }
}

export const useAdvancedSearchStore = create(immer((set, get) => {
    return {
        hasSearchedAdvanced: false,
        setHasSearchedAdvanced: (b) => {
            set(s => {
                s.hasSearchedAdvanced = b
            })
        },
        searchMode: "REGULAR", // "REGULAR" or "ADVANCED"
        setSearchMode: (mode) => {
            set(s => {
                s.searchMode = mode
            })
        },
        showAdvanceFilter: false,
        setShowAdvanceFilter: (b) => {
            set(s => {
                s.showAdvanceFilter = b
            })
        },
        userRecords: userRecordFields,
        appliedUserRecords: [
            {
                field: "",

            }
        ],
        canAddNewUserRecord: false,
        addNewAppliedUserRecord: () => {
            set(s => {
                s.appliedUserRecords.push({
                    field: "",
                })
                s.canAddNewUserRecord = false
            })
        },
        modifyAppliedUserRecord: (index, key, value) => {
            set(s => {
                s.appliedUserRecords[index][key] = value
            })
        },
        changeAddNewUserRecord: (canAdd) => {
            set(s => {
                s.canAddNewUserRecord = canAdd
            })
        },
        profileRecords: profileRecordFields,
        appliedProfileRecords: [
            {
                field: "",

            }
        ],
        canAddNewProfileRecord: false,
        addNewAppliedProfileRecord: () => {
            set(s => {
                s.appliedProfileRecords.push({
                    field: "",
                })
                s.canAddNewProfileRecord = false
            })
        },
        modifyAppliedProfileRecord: (index, key, value) => {
            set(s => {
                s.appliedProfileRecords[index][key] = value
            })
        },
        changeAddNewProfileRecord: (canAdd) => {
            set(s => {
                s.canAddNewProfileRecord = canAdd
            })
        },
        saleRecords: saleRecordFields,
        appliedSaleRecords: [
            {
                field: ""
            }
        ],
        canAddNewSaleRecord: false,
        addNewAppliedSaleRecord: () => {
            set(s => {
                s.appliedSaleRecords.push({
                    field: "",
                })
                s.canAddNewSaleRecord = false
            })
        },
        modifyAppliedSaleRecord: (index, key, value) => {
            set(s => {
                s.appliedSaleRecords[index][key] = value
            })
        },
        changeAddNewSaleRecord: (canAdd) => {
            set(s => {
                s.canAddNewSaleRecord = canAdd
            })
        },
        compareCondition: "ANY", // "ANY" or "ALL"
        changeCompareCondition: (condition) => {
            set(s => {
                s.compareCondition = condition
            })
        },
        returnTypes: [
            {
                label: "Regular Fields",
                value: "REGULAR_FIELDS"
            },
            {
                label: "Extended Fields",
                value: "EXTENDED_FIELDS"
            }
        ],
        returnType: "REGULAR_FIELDS", // "REGULAR_FIELDS" or "EXTENDED_FIELDS"
        changeReturnType: (type) => {
            set(s => {
                s.returnType = type
            })
        },
        getPayloadForApi: () => {
            const state = get()
            const payload = {
                filters: {
                    user: [],
                    profile: [],
                    sku: [],
                },
                extended_fields: false,
                compareCondition: "any"
            }

            state.appliedUserRecords.forEach((item) => {
                if (item.field && item.condition) {
                    payload.filters.user.push({
                        field: item.field,
                        condition: item.condition,
                        value: item.value
                    })
                }
            })

            state.appliedProfileRecords.forEach((item) => {
                if (item.field && item.condition) {
                    payload.filters.profile.push({
                        field: item.field,
                        condition: item.condition,
                        value: item.value || ""
                    })
                }
            })
            state.appliedSaleRecords.forEach((item) => {
                if (item.field) {
                    payload.filters.sku.push({
                        purchased: item.field === "has_purchased",
                        sku_id: item.value || ""
                    })
                }
            })

            payload.extended_fields = state.returnType === "EXTENDED_FIELDS"
            payload.compareCondition = state.compareCondition == "ANY" ? "any" : "all"
            return payload
        },
        clearAll: () => {
            set(s => {
                s.hasSearchedAdvanced = false
                s.appliedUserRecords = [
                    {
                        field: "",
                    }
                ];
                s.appliedProfileRecords = [
                    {
                        field: "",
                    }
                ];
                s.appliedSaleRecords = [
                    {
                        field: ""
                    }
                ];
                s.compareCondition = "ANY"
                s.returnType = "REGULAR_FIELDS"
            })
        }
    }
}))
